import { logUnhandledMutationError as defaultLogUnhandledMutationError } from '../logger/logUnhandledMutationError';
import { createUseBosMutation } from './createUseBosMutation';
export const createUseAppMutation = ({ useEnqueueErrorSnackbar, useDefaultErrorMessage, logUnhandledMutationError = defaultLogUnhandledMutationError, }) => (params) => {
    const enqueueErrorSnackbar = useEnqueueErrorSnackbar();
    const defaultErrorMessage = useDefaultErrorMessage();
    const handleUnhandledError = (error, message) => {
        logUnhandledMutationError(error);
        enqueueErrorSnackbar(message ?? defaultErrorMessage);
    };
    return createUseBosMutation({
        onUnhandledError: handleUnhandledError,
    })(params);
};
